import { createSlice } from '@reduxjs/toolkit'

export const storeSlice = createSlice({
  name: 'store',
  initialState: {
    stores: [] as string[],
  },
  reducers: {
    setStores: (state, action) => {
      state.stores = action.payload
    },
  },
})

// Action creators are generated for each case reducer function
export const { setStores } = storeSlice.actions

export default storeSlice.reducer
